<template>
    <div class="hiddenScrollbar detail">
        <div class="Site-Info box">
            <w-image :pictures="community.pictures" ref="wImage" @click.native="showImages" name="外观"
                :state="community.state"
                :brandName="community.otherResourceData ? community.otherResourceData.brandName : ''"></w-image>
            <div class="Right">
                <div class="Right-Top">
                    <div class="Right-One Right-Padding">
                        <span v-if="community.score">{{ community.score }}<span style="font-size: 15px">分</span></span>
                        <span style="font-size: 14px;" v-else>暂无评分</span>
                    </div>
                    <div class="Right-One-Site Right-Padding">
                        <p>会场类型：{{ community.thirdData.site_type }}</p>
                        <p>会场数量：{{ community.thirdData.site_num }}</p>
                    </div>
                    <div class="Right-Two Right-Padding">
                        <el-rate v-if="community.star" v-model="community.star" :max="community.star" disabled>
                        </el-rate>
                        <i v-if="community.addressCn" class="el-icon-location-outline van-icon" />
                        <span class="ellipsis">{{ community.addressCn }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="community.introduction" class="Introduce box box-kuang">
            <p style="display: flex;"><svg-icon class="icon-title" iconClass="jianjie"></svg-icon>简介</p>
            <p class="box-content" style="color: #323232;">{{ community.introduction }}</p>
        </div>

        <div v-if="community.thirdData.time_info_list" class="Introduce box box-kuang">
            <p style="display: flex;"><svg-icon class="icon-title" iconClass="businessHours"></svg-icon>营业时间</p>
            <p class="box-content" style="color: #323232;">{{ community.thirdData.time_info_list.join("、") }}</p>
        </div>
        <div v-if="community.thirdData.pdf_downloads_info.length > 0" class="Service box box-kuang">
            <p style="display: flex;"><svg-icon class="icon-title" iconClass="relatedData"></svg-icon>相关资料</p>
            <a class="box-content" target="_blank" style="color: #323232;cursor: pointer;text-decoration: underline;"
                v-for="(item, index) in community.thirdData.pdf_downloads_info" :key="index" :href="item">{{
                    item.split('/').pop() }}</a>
        </div>
        <div style="width: 6rem;" v-if="community.thirdData.site_room_list && community.thirdData.site_room_list.length > 0"
            class="Service box box-kuang">
            <p style="display: flex;"><svg-icon class="icon-title" iconClass="relatedData"></svg-icon>会场资料</p>
            <el-table :data="community.thirdData.site_room_list" border max-height="250" style="width: 100%">
                <el-table-column fixed align="center" prop="site_name" width="100" label="会场名称">
                </el-table-column>
                <el-table-column align="center" prop="name" width="60" label="高(m)">
                </el-table-column>
                <el-table-column align="center" prop="site_height" width="60" label="长(m)">
                </el-table-column>
                <el-table-column align="center" prop="site_width" width="60" label="宽(m)">
                </el-table-column>
                <el-table-column align="center" prop="site_area" width="80" label="面积(m²)">
                </el-table-column>
                <el-table-column v-for="(item, index) in siteImg" :key="index" align="center" width="60">
                    <template slot="header" slot-scope="scope">
                        <img class="imgs" :src="item.url" alt="">
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row[item.key].people_number }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="community.thirdData.mp4.length > 0" class="Service box box-kuang">
            <p style="display: flex;"><svg-icon class="icon-title" iconClass="video"></svg-icon>相关视频</p>
            <a class="box-content" target="_blank" style="color: #323232;cursor: pointer;text-decoration: underline;"
                v-for="(url, index) in community.thirdData.mp4" :key="index" :href="url">{{ url.split('/').pop() }}</a>
        </div>
        <div v-if="community.thirdData.sb_info_list" class="Service box box-kuang">
            <p style="display: flex;"><svg-icon class="icon-title" iconClass="siteSheshi"></svg-icon>会议设施</p>
            <p class="box-content" style="color: #323232;">{{ community.thirdData.sb_info_list.join("、") }}</p>
        </div>
        <div v-if="community.thirdData.ts_info_list" class="Service box box-kuang">
            <p style="display: flex;"><svg-icon class="icon-title" iconClass="equipment"></svg-icon>特殊设备</p>
            <p class="box-content" style="color: #323232;">{{ community.thirdData.ts_info_list.join("、") }}</p>
        </div>
        <div class="Traffic box box-kuang">
            <p style="display: flex;"><svg-icon class="icon-title" iconClass="guanwang"></svg-icon>官网及联系电话</p>
            <p v-if="community.website" class="box-content" style="color: #323232;">web：{{ community.website }}</p>
            <p v-if="community.phone" class="box-content" style="color: #323232;">phone：{{ community.phone }}</p>
        </div>
    </div>
</div></template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import { dateUtil } from "@/mixins/dateUtil";
export default {
    name: '',
    components: {},
    props: ['community', 'checkBudgets'],
    mixins: [dateUtil],
    // 定义属性
    data() {
        return {
            noImage: require('@/assets/png/noImage.png'),
            spanCheck: 1,
            siteImg: [
                {
                    url: require('@/assets/png/site-img/bankett.jpg'),
                    key: 'bankett_layout'
                },
                {
                    url: require('@/assets/png/site-img/empfang.jpg'),
                    key: 'empfang_layout'
                },
                {
                    url: require('@/assets/png/site-img/gala.jpg'),
                    key: 'gala_layout'
                },
                {
                    url: require('@/assets/png/site-img/parlamentarisch.jpg'),
                    key: 'parlamentarisch_layout'
                },
                {
                    url: require('@/assets/png/site-img/reihen.jpg'),
                    key: 'reihen_layout'
                }
            ]
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        showImages() {
            this.$refs.wImage.show()
        },
        setSpanCheck(spanCheck) {
            this.spanCheck = spanCheck
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
.imgs {
    width: 0.27rem;
    height: 0.27rem;
}

.box {
    box-shadow: 2px 2px 5px #e5e4e4;
}

.detail {
    overflow-y: scroll;
    position: absolute;
    top: 60px;
    bottom: 0;

    .Price {
        background: #fff;
        border: 1px solid #e5e4e4;
        margin: 20px;
        display: flex;
        padding: 10px;
        display: flex;
        flex-direction: column;

        >p:nth-child(1) {
            font-weight: 700;
        }
    }

    .Introduce {
        background: #fff;
        border: 1px solid #e5e4e4;
        margin: 20px;
        display: flex;
        padding: 10px;
        display: flex;
        flex-direction: column;

        >p:nth-child(1) {
            font-weight: 700;
        }

        >p:nth-child(2) {
            text-align: justify;
            text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
            text-align-last: left;
        }
    }

    .Site-Info {
        background: #fff;
        border: 1px solid #e5e4e4;
        margin: 20px;
        height: 150px;
        display: flex;

        .Right {
            padding: 10px;
            position: relative;
            width: -webkit-fill-available;

            .Right-One {
                font-size: 24px;
                color: #646464;
                font-weight: 200;
                display: flex;

                /deep/ .el-icon-star-on {
                    color: #db4e1a !important;
                    font-size: 18px;
                }

                /deep/ .el-rate {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    padding-left: 5px;
                }

                >span {
                    display: flex;
                    align-items: center;
                }

                >p {
                    font-size: 0.12rem;
                    display: flex;
                    align-self: center;
                    margin-left: 8px;
                }
            }

            .Right-One-Site {
                color: #646464;
                font-weight: 200;

                >p {
                    font-size: 0.12rem;
                    display: flex;
                    align-self: center;
                    margin-right: 5px;
                }
            }

            .Right-Two {
                font-weight: 200;
            }


        }
    }
}

.icon-class {
    height: 12px;
    width: 12px;
    display: flex;
    align-self: center;
    margin-right: 2px;
    color: blue;
}

.icon-title {
    margin-right: 8px;
    display: flex;
    align-self: center;
    height: 18px;
    width: 18px;
}

.Right-Padding {
    padding-top: 2px;
}

.box-kuang {
    background: #fff;
    border: 1px solid #e5e4e4;
    margin: 20px;
    display: flex;
    padding: 10px;
    display: flex;
    flex-direction: column;

    >p:nth-child(1) {
        font-weight: 700;
        align-items: center;
        padding-bottom: 7px;
    }
}

// p标签内每一行的文本下划线设置
.box-content {
    display: inline-block;
    position: relative;
    text-decoration: underline dashed;
    text-decoration-color: #e5e5e5;
    text-underline-offset: 4.8px;
    line-height: 1.6;
}

.Right-Top {
    margin-top: 10px;
}

.Price-Top {
    display: flex;
    justify-content: space-between;
    width: 100%;

    >span {
        border: 1px solid #02A0C6;
        flex: 1;
        text-align: center;
        line-height: 1.5;
        margin-right: -1px;
        display: flex;
        justify-content: center;

        &:hover {
            cursor: pointer;
        }
    }

    .Price-Hang {
        top: 15px;
    }

    .active-span {
        color: white;
        background-color: #02A0C6;
    }
}
</style>